import { render } from "./time-swap-confirm.view.vue?vue&type=template&id=63f2776e&scoped=true&ts=true"
import script from "./time-swap-confirm.view.vue?vue&type=script&lang=ts"
export * from "./time-swap-confirm.view.vue?vue&type=script&lang=ts"

import "./time-swap-confirm.view.vue?vue&type=style&index=0&id=63f2776e&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f2776e"]])

export default __exports__